<script>
  import Login from './Login.svelte'
  import Shell from './Shell.svelte'

  let { authenticated = false, email = '', dev_email = '', dev_password = '' } = $props()
</script>

{#if authenticated}
  <Shell {email} />
{:else}
  <Login defaultEmail={dev_email} defaultPassword={dev_password} />
{/if}
